import { NavLink } from 'react-router-dom';
import samantha1 from '../../assets/samantha1.webp';
import samNeon from '../../assets/samNeon.webp';
import samBeach1 from '../../assets/samBeach1.webp';
import styles from './StayAwhileSection.module.css';

const contentItems = [
  {
    id: 1,
    image: samantha1,
    title: 'About Me',
    link: '/about',
  },
  {
    id: 2,
    image: samNeon,
    title: 'Watch the Videos',
    link: 'https://www.youtube.com/@samanthashenolguin',
    external: true,
  },
  {
    id: 3,
    image: samBeach1,
    title: 'Listen to my Music',
    link: '/media',
  },
];

const StayAwhileSection = () => {
  return (
    <section className={styles.section}>
      <h2 className={styles.heading}>Stay Awhile</h2>
      <div className={styles.cardContainer}>
        {contentItems.map((item, index) =>
          item.external ? (
            <a
              href={item.link}
              key={item.id}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.card}
            >
              <img src={item.image} alt={item.title} className={styles.image} />
              <div className={styles.textContainer}>
                <span className={styles.number}>{String(index + 1).padStart(2, '0')}</span>
                <span className={styles.title}>{item.title}</span>
              </div>
            </a>
          ) : (
            <NavLink
              to={item.link}
              state={item.title === 'Listen to my Music' ? { scrollTo: 'listen' } : {}}
              key={item.id}
              className={styles.card}
            >
              <img src={item.image} alt={item.title} className={styles.image} />
              <div className={styles.textContainer}>
                <span className={styles.number}>{String(index + 1).padStart(2, '0')}</span>
                <span className={styles.title}>{item.title}</span>
              </div>
            </NavLink>
          )
        )}
      </div>
    </section>
  );
};

export default StayAwhileSection;
